import {request} from '@/helpers/apiClient'
import {ACTIVITY_CONFIG} from '@/utils/constants/apiConfig/activityConfig'

export const handleCreateActivity = async req_param => {
  return await request(ACTIVITY_CONFIG.ACTIVITIES, req_param)
}
export const handleGetActivity = async (queryParams, body) => {
  const payload = body? {data: body}: '';
  return await request(ACTIVITY_CONFIG.GET_ACTIVITY,  payload, queryParams)
}
export const getActivityCsvFile = (body) => request(ACTIVITY_CONFIG.ACTIVITY_CSV_DOWNLOAD, { data: body })

export const handleSaveDraftActivity = async req_param => {
  return await request(ACTIVITY_CONFIG.SAVE_DRAFT_ACTIVITY, req_param)
}

export const handleUpdateDraftActivity = async (req_param) => {
  return await request(ACTIVITY_CONFIG.UPDATE_DRAFT_ACTIVITY, req_param)
}
